const ACP_UNAUTHORIZED_STORAGE_KEY = "acpUnauthorizedBanner";

export const UNAUTHORIZED_LOGOUT_STATE = "acpUnauthorized";

export const isAcpUnauthorizedSearch = (search?: string): boolean => {
  const params = new URLSearchParams(search ?? "");
  const flag = params.get("acpUnauthorized");
  if (flag === "1" || flag === "true") {
    return true;
  }
  return params.get("state") === UNAUTHORIZED_LOGOUT_STATE;
};

export const latchAcpUnauthorizedFlag = (): void => {
  sessionStorage.setItem(ACP_UNAUTHORIZED_STORAGE_KEY, "1");
};

export const isAcpUnauthorizedBannerLatched = (): boolean =>
  sessionStorage.getItem(ACP_UNAUTHORIZED_STORAGE_KEY) === "1";

/** Read-only: query signal or existing latch. Safe to call during render. */
export const hasAcpUnauthorizedBanner = (search?: string): boolean =>
  isAcpUnauthorizedSearch(search) || isAcpUnauthorizedBannerLatched();

export const consumeAcpUnauthorizedFlag = (search?: string): boolean => {
  if (isAcpUnauthorizedSearch(search)) {
    latchAcpUnauthorizedFlag();
    return true;
  }
  return isAcpUnauthorizedBannerLatched();
};

export const clearAcpUnauthorizedFlag = (): void => {
  sessionStorage.removeItem(ACP_UNAUTHORIZED_STORAGE_KEY);
};

export const searchWithoutAcpUnauthorized = (search: string): string => {
  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  params.delete("acpUnauthorized");
  if (params.get("state") === UNAUTHORIZED_LOGOUT_STATE) {
    params.delete("state");
  }
  const next = params.toString();
  return next ? `?${next}` : "";
};

export const stripAcpUnauthorizedFromUrl = (): void => {
  const url = new URL(window.location.href);
  if (
    !url.searchParams.has("acpUnauthorized")
    && url.searchParams.get("state") !== UNAUTHORIZED_LOGOUT_STATE
  ) {
    return;
  }
  const nextSearch = searchWithoutAcpUnauthorized(url.search);
  window.history.replaceState(window.history.state, "", `${url.pathname}${nextSearch}${url.hash}`);
};

export const getSiteAdminUrl = (hostname = window.location.hostname): string => {
  if (/^mylogin-v2\.freedommortgage\.com$/i.test(hostname)) {
    return "https://siteadmin.freedommortgage.com";
  }
  const env = /mylogin-(dev|test|uat)/i.exec(hostname)?.[1]?.toLowerCase() ?? "test";
  return `https://siteadmin-${env}.freedommortgage.com`;
};
